import { useMemo } from 'react';
import { FieldType } from 'modules/queryBuilder/types';
import { SelectOption } from 'modules/queryBuilder/contexts';
import { useDisableCatalogOption } from './useDisableCatalogOption';
import { useOptionsWithMatchesCatalog } from './useOptionsWithMatchesCatalog';
import { useMatchesCatalogContext } from '../../../../contexts/matchesCatalog';
import { useComparatorOptionsWithInvalidComparator } from '../../hooks/useComparatorOptionsWithInvalidComparator';

export const useCustomComparatorOptions = (
  options: SelectOption<string>[],
  value: string | null,
  fieldType?: FieldType,
) => {
  const { isMatchesCatalogSelected } = useMatchesCatalogContext();
  const disableCatalogOption = useDisableCatalogOption(value);
  const comparatorOptionsWithInvalidComparator = useComparatorOptionsWithInvalidComparator(
    value,
    options,
  );
  const optionsWithMatchesCatalog = useOptionsWithMatchesCatalog(
    comparatorOptionsWithInvalidComparator,
    fieldType,
  );

  return useMemo(() => {
    return isMatchesCatalogSelected
      ? optionsWithMatchesCatalog.map(disableCatalogOption)
      : optionsWithMatchesCatalog;
  }, [options, isMatchesCatalogSelected]);
};
